export default __webpack_public_path__ + "static/media/Message.5de12e3c.mp3";